var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ulsemo-stepper"},_vm._l((_vm.steps),function(step){return _c('div',{key:step,class:{
      'ulsemo-stepper__step': true,
      [`ulsemo-stepper__step-${step}--enabled`]:
        step <= _vm.current_step,
      [`ulsemo-stepper__step-${step}`]: true,
    },on:{"click":function($event){return _vm.$router.push({ path: `/${_vm.GUIDE}/step_${step + 1}` })}}},[_c('span',[_vm._v(_vm._s(step))]),(step === 4)?_c('div',[_c('div',{staticClass:"ulsemo-stepper__step--triangle"}),_c('div',{staticClass:"ulsemo-stepper__step--ellipse"})]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }